import React, { useEffect, useState } from 'react'
import { ChecklistServicesApi } from '../../service/api/ChecklistServicesApi';
import SubmitButton from '../../components/controls/SubmitButton/SubmitButton';

import { useHistory } from "react-router-dom";

import styles from './ViewChecklist.module.css';
import ViewChecklistRow from './ViewChecklistRow';
import Loading from '../../components/Loading/Loading';
import InfoIconWithTooltip from "../../UI/InfoIconWithTooltip/InfoIconWithTooltip";
import { getFirstMultiDigitNumber } from '../../globalFunctions/globalFunctions';

let urlSearchParams = new URLSearchParams(window.location.search);
let params = Object.fromEntries(urlSearchParams.entries());

let queryStringChecklistId = params["checklistId"];

const hierarchyArray = ["question", "ambito", "requisito", "principio", "fatQual"]; // in this order so that for example fatQual > requisito

const ViewChecklist = (props) => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [finalData, setFinalData] = useState([]);
  const [opScopes, setOpScopes] = useState([]);
  const [qualitativeAnswerTypes, setQualitativeAnswerTypes] = useState();
  const [checklistId, setChecklistId] = useState(); // if the id that is being sent to the backend
  const [checklistName, setChecklistName] = useState();
  const [qualitativeEvaluationOnly, setQualitativeEvaluationOnly] = useState(true);
  const [originalData, setOriginalData] = useState(); // will be used on save/evaluate

  const history = useHistory();

  useEffect(() => {
    let mounted = true;
    setIsLoading(true);

    console.log(queryStringChecklistId)

    // const fattoriQualificanti = require("./checklist-1-data.json");
    // setOriginalData(fattoriQualificanti);

    urlSearchParams = new URLSearchParams(window.location.search);
    params = Object.fromEntries(urlSearchParams.entries());
    queryStringChecklistId = params["checklistId"];
    setChecklistId(queryStringChecklistId);

    const checklistServicesApi = new ChecklistServicesApi();

    checklistServicesApi.getChecklistById(queryStringChecklistId, (error, checklistInfo) => {
      if (mounted) {
        if (!error) {
          const qualitativeAnswers = checklistInfo.checklistQualitativeAnswerTypes;
          console.log("checklist info: ", checklistInfo);
          qualitativeAnswers.sort((a, b) => a.id > b.id ? 1 : -1);
          setQualitativeAnswerTypes(qualitativeAnswers);
          props.setChecklistName(checklistInfo.name);

          checklistServicesApi.getChecklistCosoHierarchyById(queryStringChecklistId, (error, data) => {
            if (mounted) {
              if (!error) {
                setOriginalData(data);
                const fattoriQualificanti = data;

                initialConfiguration(queryStringChecklistId, fattoriQualificanti);
              } else {
                setError(() => {
                  throw new Error("");
                  // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
                })
              }
            }
          });
        } else {
          setError(() => {
            throw new Error("");
            // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
          })
        }
      }
    });

    return () => {
      mounted = false;
    }
  }, []);

  const initialConfiguration = (queryStringChecklistId, fattoriQualificanti) => {
    const initialOpScopes = [];
    console.log("fattoriQualificanti: ", fattoriQualificanti)

    // creating the initialOpScopes array
    let opScopesArrayCreated = false;
    for (let fatQual of fattoriQualificanti) {
      for (let principio of fatQual.checklistCosoPrincipi) {
        for (let requisito of principio.checklistCosoRequisiti) {
          for (let ambito of requisito.checklistCosoAmbiti) {
            if (ambito.checklistQualitativeQuestions && ambito.checklistQualitativeQuestions.length > 0) { // only needed if I receive ambiti with no questions
              for (let question of ambito.checklistQualitativeQuestions) {
                for (let opScope of question.checklistQualitativeQuestionOperationalScopes) {
                  const tempOS = {
                    id: opScope.operationalScope.id,
                    name: opScope.operationalScope.name,
                    tooltip: opScope.operationalScope.tooltip,
                    infoIconIsVisible: false
                  }
                  initialOpScopes.push(tempOS);
                  console.log("qualitative opScope", initialOpScopes)
                }
                opScopesArrayCreated = true;
                break;
              }
            }
            console.log("Pre IF")
            if (ambito.checklistQuantitativeDrivers && ambito.checklistQuantitativeDrivers.length > 0) {
              for (let driver of ambito.checklistQuantitativeDrivers) {
                for (let question of driver.checklistQuantitativeQuestions) {
                  if (question.checklistQuantitativeQuestionOperationalScopes && question.checklistQuantitativeQuestionOperationalScopes.length > 0) {
                    for (let opScope of question.checklistQuantitativeQuestionOperationalScopes) {
                      const tempOS = {
                        id: opScope.operationalScope.id,
                        name: opScope.operationalScope.name,
                        active: opScope.operationalScope.active,
                        infoIconIsVisible: false
                      };
                      initialOpScopes.push(tempOS);
                      console.log("quantitativeee opScope", initialOpScopes)
                    }
                    opScopesArrayCreated = true;
                    break;
                  }
                }
              }
            }
            if (opScopesArrayCreated) break;
          }
          if (opScopesArrayCreated) break;
        }
        if (opScopesArrayCreated) break;
      }
      if (opScopesArrayCreated) break;
    }

    initialOpScopes.sort((a, b) => a.id > b.id ? 1 : -1);
    console.log("sorted opScopes: ", initialOpScopes);

    setOpScopes(initialOpScopes);

    // SORTING ALL THE ARRAYS
    fattoriQualificanti.sort((a, b) => a.position > b.position ? 1 : -1);
    for (let fatQual of fattoriQualificanti) {
      fatQual.checklistCosoPrincipi.sort((a, b) => a.position > b.position ? 1 : -1);
      for (let principio of fatQual.checklistCosoPrincipi) {
        principio.checklistCosoRequisiti.sort((a, b) => a.position > b.position ? 1 : -1);
        for (let requisito of principio.checklistCosoRequisiti) {
          requisito.checklistCosoAmbiti.sort((a, b) => a.position > b.position ? 1 : -1);
          for (let ambito of requisito.checklistCosoAmbiti) {
            if (ambito.checklistQualitativeQuestions.length > 0) {
              ambito.checklistQualitativeQuestions.sort((a, b) => a.position > b.position ? 1 : -1);
            } else {
              ambito.checklistQuantitativeDrivers.sort((a, b) => a.position > b.position ? 1 : -1);
              for (let checklistQuantitativeDriver of ambito.checklistQuantitativeDrivers) {
                checklistQuantitativeDriver.checklistQuantitativeQuestions.sort((a, b) => a.position > b.position ? 1 : -1);
              }
            }
          }
        }
      }
    }
    console.log("sortedData: ", fattoriQualificanti);

    let mainData = [];
    for (let fatQual of fattoriQualificanti) {
      mainData.push(createDataObject(fatQual, "fatQual")); // id, position(?probably not needed) title, type, operationalScopes values
      for (let principio of fatQual.checklistCosoPrincipi) {
        mainData.push(createDataObject(principio, "principio"));
        for (let requisito of principio.checklistCosoRequisiti) {
          mainData.push(createDataObject(requisito, "requisito"));
          for (let ambito of requisito.checklistCosoAmbiti) {
            if (ambito.checklistQualitativeQuestions.length > 0) {
              console.log("In IF")
              mainData.push(createDataObject(ambito, "ambito"));
              for (let question of ambito.checklistQualitativeQuestions) {
                console.log("question", question)
                mainData.push(
                  createQuestionObject(
                    question,
                    question.checklistQualitativeQuestionOperationalScopes,
                    fatQual.id,
                    principio.id,
                    requisito.id,
                    ambito.id,
                    initialOpScopes,
                    "qualitative"
                  ));
              }
            } else {
              // if (ambito.checklistQuantitativeDrivers && ambito.checklistQuantitativeDrivers.length > 0) {
              console.log("ELSE")
              mainData.push(createDataObject(ambito, "ambito"));
              setQualitativeEvaluationOnly(false);
              for (let checklistQuantitativeDriver of ambito.checklistQuantitativeDrivers) {
                console.log("checklistQuantitativeDriver",checklistQuantitativeDriver)
                for (let question of checklistQuantitativeDriver.checklistQuantitativeQuestions) {
                  mainData.push(
                    createQuestionObject(
                      question,
                      question.checklistQuantitativeQuestionOperationalScopes,
                      fatQual.id,
                      principio.id,
                      requisito.id,
                      ambito.id,
                      initialOpScopes,
                      "quantitative"
                    ));
                }
              }
            }
          }
        }
      }
    }

    // fatQual "span" property will determine the number of rows that this title will occupy
    let count = 0;
    for (let i = mainData.length - 1; i >= 0; i--) {
      const arrayEl = mainData[i];
      // length of each fattore qualificante
      if (arrayEl.type && arrayEl.type === "fatQual") {
        arrayEl.span = count;
        // Object.defineProperty(arrayEl, "span", { value: count });
        count = 0;
      } else {
        count++;
      }
    }

    setFinalData([...mainData]);
    setIsLoading(false);
  }

  const createDataObject = ({ id, title, tooltip, position }, givenType) => {

    return {
      id,
      title,
      tooltip,
      type: givenType,
      isHidden: false,
      isCollapsed: false,
      ...(givenType === "principio" && { position })
    };
  }

  const createQuestionObject = (
    {
      position,
      question: title,
      id: questionId,
      tooltip,
      displayId,
      note
    },
    opScopesObjects,
    fatQualId,
    principioId,
    requisitoId,
    ambitoId,
    operationalScopes,
    questionType,
  ) => {
    // transform the opScopes information
    const tempOpScopes = [];
    console.log("operationalScopesz",operationalScopes)
    for (let opScope of operationalScopes) {
      for (let opScopesObject of opScopesObjects) {
        if (opScopesObject.operationalScope.name === opScope.name) {
          let opScopeName = opScopesObject.operationalScope.name;
          let opScopeAnswer;
          console.log("questionType",questionType)
          console.log("opScopesObject",opScopesObject)
          if (questionType === "qualitative") {
            opScopeAnswer = opScopesObject.checklistQualitativeAnswerType ? opScopesObject.checklistQualitativeAnswerType.answer : null
          } else {
            if (opScopesObject.answer === null) {
              opScopeAnswer = "N/A";
            } else if (opScopesObject.answer === -9999) { // unanswered field
              opScopeAnswer = "";
            } else {
              opScopeAnswer = opScopesObject.answer;
            }
          }
          let opScopeEnabled = opScopesObject.enabled;
          tempOpScopes.push({ name: opScopeName, answer: opScopeAnswer, enabled: opScopeEnabled });
          break;
        }
      }
    }

    return {
      operationalScopes: tempOpScopes,
      position,
      title,
      tooltip,
      displayId,
      fatQualId,
      principioId,
      requisitoId,
      ambitoId,
      questionId,
      questionType, // qualitative, quantitative
      note,
      isHidden: false
    };
  };

  // Table Header
  const renderHeader = () => {
    console.log("Header rendered");
    return (
      <thead>
        <tr>
          <th rowSpan="2" className={`${styles.fatQual} bg-transparent border-bottom-0`}></th>
          <th rowSpan="2" className={`${styles.bgGrey} ${styles.questionsWidth} text-white align-middle`}>
            Questions
          </th>
          <th colSpan={opScopes.length} className={`${styles.bgGrey} text-white align-middle`}>
            Operational Scopes
          </th>
          <th rowSpan="2" className={`${styles.bgGrey} ${styles.notesWidth} text-white align-middle`}>NOTE</th>
        </tr>
        <tr>
          {finalData && opScopes.map((opScope) => (
            <th key={`${opScope.id} - ${opScopes.name}`} className={`${styles.opScopeWidth} position-relative py-1 px-2`}
              onMouseEnter={(e) => showOpScopeInfoIcon(e, opScope.id)}
              onMouseLeave={(e) => hideOpScopeInfoIcon(e, opScope.id)}
            >
              {opScope.name}
              <InfoIconWithTooltip text={opScope.tooltip} show={opScope.infoIconIsVisible} />
            </th>
          ))}
        </tr>
      </thead>
    );
  }

  const showOpScopeInfoIcon = (e, osId) => {
    e.preventDefault();

    const updatedOpScopes = [...opScopes];
    updatedOpScopes.filter(os => os.id === osId)[0].infoIconIsVisible = true;

    setOpScopes(updatedOpScopes)
  };

  const hideOpScopeInfoIcon = (e, osId) => {
    e.preventDefault();

    const updatedOpScopes = [...opScopes];
    updatedOpScopes.filter(os => os.id === osId)[0].infoIconIsVisible = false;

    setOpScopes(updatedOpScopes)
  };

  const collapseElement = function (index, isCollapsedUpdatedValue) {
    // clicked elements will never be questions
    let newData = [...finalData];
    newData[index].isCollapsed = isCollapsedUpdatedValue;
    const record = newData[index];
    let newIsHiddenValue = false;
    if (isCollapsedUpdatedValue === true) {
      newIsHiddenValue = true;
    }

    console.log("isHidden new value: ", isCollapsedUpdatedValue)
    // let invalidInputFound = false;
    // DESCRIPTION of all the variables used below: (hierarchy is the order of the "layers", from question to fatQual)
    // 1. hierarchyLevelOfSelectedElement: The hierarchy of the element that was clicked
    // 2. currentCollapsedElementHierarchy: The hierachy of the current element that was detected to be collapsed while iterating through the newData array
    // 3. elHierarchy: the hierarchy of the current iteration element
    // 4. isInsideCollapsedElement: a boolean that checks if we are inside a collapsed element

    let currentCollapsedElementHierarchy = 0;
    let isInsideCollapsedElement = false;
    const hierarchyLevelOfSelectedElement = hierarchyArray.findIndex(item => item === record.type); //defining the hierarchy level of the selected element
    console.log("hierarchyLevelOfSelectedElement: ", hierarchyLevelOfSelectedElement);
    for (let i = index + 1; i < newData.length; i++) {
      let el = newData[i];
      if (el.type) {
        let elHierarchy = hierarchyArray.findIndex(type => type === el.type);
        if (elHierarchy < hierarchyLevelOfSelectedElement) {
          if (el.isCollapsed && !isInsideCollapsedElement) {
            isInsideCollapsedElement = true;
            currentCollapsedElementHierarchy = hierarchyArray.findIndex(type => type === el.type);
            el.isHidden = newIsHiddenValue;
            // if (isCollapsedUpdatedValue === true && !invalidInputFound) {
            //   if (!el.hasValidChildren) {
            //     invalidInputFound = true;
            //   }
            // }
            continue;
          }
          if (isInsideCollapsedElement) {
            if (elHierarchy >= currentCollapsedElementHierarchy) {
              if (el.isCollapsed) {
                currentCollapsedElementHierarchy = hierarchyArray.findIndex(type => type === el.type);
                // if (isCollapsedUpdatedValue === true && !invalidInputFound) {
                //   if (!el.hasValidChildren) {
                //     invalidInputFound = true;
                //   }
                // }
              } else {
                isInsideCollapsedElement = false;
              }
              el.isHidden = newIsHiddenValue;
            }
          } else {
            el.isHidden = newIsHiddenValue;
          }
        } else break;
      } else {
        // element is a question
        if (!isInsideCollapsedElement) {
          el.isHidden = newIsHiddenValue;
          // if (isCollapsedUpdatedValue === true && !invalidInputFound) {
          //   for (const value of Object.values(el.invalidInputs)) {
          //     if (value === true) {
          //       invalidInputFound = true;
          //       break;
          //     }
          //   }
          // }
        }
      }
    }
    // newData[index].hasValidChildren = invalidInputFound ? false : true;

    setFinalData(newData);
  }


  let transformedData = finalData && [...finalData];

  let fatQualSpan = 0;
  for (let i = transformedData.length - 1; i >= 0; i--) {
    let el = transformedData[i];
    if (el.type && el.type === "fatQual") { // we don't count the elements that are hidden
      el.span = fatQualSpan;
      fatQualSpan = 0;
    } else {
      if (!el.isHidden)
        fatQualSpan++;
    }
  }

  let principioDisplayId = 1;
  let tableData = transformedData && transformedData.map((el, index) => {
    if (el.type === "principio") {
      principioDisplayId = getFirstMultiDigitNumber(el.title);
    }
    if (el.type && el.type === "fatQual") {
      console.log(el.span);
      return (
        <tr key={el.id}>
          {/* style={{background: `rgb(${red+=9}, ${green+=26}, ${blue+=16})`}} */}
          <td className={styles.fatQual} rowSpan={el.span + 1}>
            <span className={styles.verticalText}>{el.title}</span>
          </td>
        </tr>
      );
    } else {
      if (!el.isHidden) {
        return (
          <ViewChecklistRow
            key={
              el.type
                ? el.type + "-" + el.id
                : el.questionType + "-" + index
            }
            title={el.title}
            opScopes={el.operationalScopes}
            type={el.type}
            pos={index}
            questionType={el.questionType}
            isCollapsed={el.isCollapsed}
            hasValidChildren={el.hasValidChildren}
            tooltip={el.tooltip}
            principioId={principioDisplayId}
            displayId={el.displayId}
            qualitativeAnswers={qualitativeAnswerTypes.map(el => el.answer)}
            qualEvaluationOnly={qualitativeEvaluationOnly}
            opScopesList={opScopes}
            note={el.note}
            collapseElement={collapseElement}
          />
        );
      }
    }
  });

  const tableStyle = `${styles.border2px} ${styles.table} text-center table`;
  let table = (
    <table className={` ${tableStyle} ${styles.tableRelative} mb-1`}>
      {/* {renderHeader()} */}
      <tbody className={styles.bodyCells}>
        {tableData}
      </tbody>
    </table>
  );
  console.log("Data: ", finalData);
  console.log("OriginalData", originalData);
  console.log("render: end");
  return (
    <div className={`position-relative outerContainer`}>
      {isLoading && <Loading />}
      {!isLoading && (
        <table className={`${tableStyle} ${styles.sticky} mb-0`}>
          {renderHeader()}
        </table>
      )}
      {!isLoading && table}
      <div className="d-flex justify-content-start ">
        <button
          className={styles.goBackButton}
          onClick={() => { history.push("/checklist-monitor") }}
        >&larr; Checklist Monitor
        </button>
      </div>
    </div>
  );
}

export default ViewChecklist;
